import React, { Component } from 'react';


class SectionBar extends Component {
  render() {
    const { color, style, direction, length } = this.props;
    const thickness = 8;
    const barStyle = {
      position: 'relative',
      zIndex: 8,
      width: 0,
      height: 0,
      borderBottom: direction === 'horizontal' ? thickness+'px '+color+' solid' : 'none',
      borderRight: direction === 'vertical' ? thickness+'px '+color+' solid' : 'none',
      display: 'block',
      left: '50%',
      backgroundColor: color,
      ...(direction === 'vertical' ? {height: length} : {}),
      ...(direction === 'horizontal' ? {width: length} : {}),
      ...(style ? style : {})};
      return (
        <span className="SectionBar" style={barStyle}></span>
      );
    }
  }
  export default SectionBar;



// WEBPACK FOOTER //
// ./src/components/Home/Section/SectionBar.jsx